// Module
var code = "<template>\n  <p t=\"general.logged_out_now\"></p>\n  <a class=\"button button--primary\" route-href=\"route: login-form\" t=\"general.backToLoginForm\"></a>\n</template>\n";
// Exports
export default code;